module.exports = __webpack_public_path__ + "files/39382aef93b0f833a61a4fa493bd0cc3.svg";